import React from 'react';

const StatusDropdown = ({ 
  orderId, 
  currentStatus, 
  allowedOptions, 
  openDropdown, 
  handleToggleDropdown, 
  handleStatusChange, 
  dropdownPosition, 
  getStatusInfo ,
  hasPermission
}) => {
  return (
    <div className="relative">
      <button
      disabled={!hasPermission('status')}
        id={`status-button-${orderId}`}
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          handleToggleDropdown(orderId);
        }}
        className="disabled:bg-gray-400 disabled:text-gray-700  disabled:cursor-not-allowed inline-flex items-center px-2 py-1.5 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none"
      >
        Statut
        <svg className="ml-1 h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 011.414 1.414l-4 4a1 0 01-1.414 0l-4-4a1 0 010-1.414z" clipRule="evenodd" />
        </svg>
      </button>

      {openDropdown === orderId && (
        <div
          className={`${dropdownPosition.isFixed ? 'fixed' : 'absolute'} rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-50`}
          role="menu"
          id={`status-menu-${orderId}`}
          style={dropdownPosition.isFixed ? {
            top: `${dropdownPosition.top}px`,
            left: `${dropdownPosition.left}px`,
            width: '180px',
            maxHeight: '250px',
            overflowY: 'auto'
          } : {
            top: '100%',
            left: '0',
            marginTop: '0.5rem',
            width: '180px',
            maxHeight: '250px',
            overflowY: 'auto'
          }}
        >
          {allowedOptions.length > 0 ? (
            allowedOptions.map((status) => (
              <div
                key={status.value}
                className="py-1"
              >
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleStatusChange(orderId, status.value, status.key);
                  }}
                  className={`block w-full text-left px-4 py-2 text-sm hover:bg-gray-100 ${currentStatus === status.value ? 'font-medium bg-gray-50' : 'text-gray-700'}`}
                >
                  <div className="flex items-center">
                    <span className={`h-2 w-2 rounded-full mr-2 ${status.color.replace('text-', 'bg-').split(' ')[1]}`}></span>
                    {status.label}
                  </div>
                </button>
              </div>
            ))
          ) : (
            <div className="py-2 px-4 text-sm text-gray-500">
              Aucune transition disponible
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default StatusDropdown;